import { ADMIN_PATH, DASHBOARD_PATH, LOGIN_PATH } from "src/constants/paths";
import { AppLocale, LOCALES } from "./localesConfig";

const STORAGE_KEY = "strm.locale";
const APP_PATHS = [DASHBOARD_PATH, ADMIN_PATH, LOGIN_PATH];

const isAppLocale = (value: string | null): value is AppLocale =>
  Boolean(value && value in LOCALES);

export const getStoredLocale = (): AppLocale | null => {
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    return isAppLocale(value) ? value : null;
  } catch {
    return null;
  }
};

export const setStoredLocale = (locale: AppLocale) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, locale);
  } catch {
    // Storage can be unavailable (private mode); the in-memory locale still applies.
  }
};

/** App routes are unprefixed and take their locale from the stored preference. */
export const isAppPath = (pathname: string): boolean =>
  APP_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`));
